import React, { lazy, Suspense } from 'react';
import {
 Redirect, Route, Router, Switch,
} from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import theme from 'src/theme';
import { PrivateRoute } from 'src/components/common/PrivateRoute';
import { openRoutes, protectedRoutes } from 'src/routes';
import { CloseButton } from 'src/components/atoms/toaster';
import WaitingIndicator from 'src/components/atoms/waitingIndicator';

const AuthPage = lazy(() => import('src/components/pages/authPage'));
const SearchForm = lazy(() => import('src/components/pages/search'));
const SearchResults = lazy(() => import('src/components/pages/searchResults'));
const ActiveJobs = lazy(() => import('src/components/pages/activeJobs'));
const TrackerPage = lazy(() => import('src/components/pages/trackerPage'));
const JobDetailsPage = lazy(() => import('src/components/pages/trackerPage/components/jobDetails'));

const routes = [
  {
    path: protectedRoutes.activeJobs,
    component: ActiveJobs,
  },
  {
    path: protectedRoutes.searchResults,
    component: SearchResults,
  },
  {
    path: protectedRoutes.search,
    component: SearchForm,
  },
  {
    path: protectedRoutes.tracker,
    component: TrackerPage,
  },
  {
    path: `${protectedRoutes.tracker}/job/:id`,
    component: JobDetailsPage,
  },
];

function App({ history }) {
  return (
    <ThemeProvider theme={{ ...theme.default }}>
      <Router history={history}>
        <Suspense fallback={(
          <WaitingIndicator
            fullScreen
            fitParent
            isFixed
          />
          )}
        >
          <Switch>
            {routes?.map((route, index) => (
              <PrivateRoute
                exact
                path={route.path}
                component={route.component}
                key={index}
              />
           ))}
            <Route path={openRoutes.root} component={AuthPage} />
            <Redirect from="*" to={openRoutes.root} />
          </Switch>
        </Suspense>
      </Router>
      <ToastContainer
        bodyClassName="toastify"
        closeButton={<CloseButton />}
        position="top-center"
      />
    </ThemeProvider>
  );
}

export default App;

